export default "__VITE_ASSET__CnNS86wK__"